var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CTabs',{attrs:{"active-tab":_vm.activeTab}},[_c('CTab',{attrs:{"title":_vm.title,"to":{ name: '医療用医薬品の詳細', id: _vm.id }}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }